import { Link } from 'react-router';
import { Button, SegmentGroup } from 'semantic-ui-react';
import { SuiTable, TitleSegment } from '@britishcouncil/react-admin';
import { usePermissions } from '@britishcouncil/react-common';

import { Permission, SpeakingCertificationListItemResult } from 'api';
import { NextDateLabel, useExaminerId } from 'components';
import { useTableState } from 'hooks';
import { useSpeakingCertificationListQuery, useSpeakingNextCertDateQuery } from 'store';
import { TableState } from 'types';
import { formatDate } from 'utils';
import { COLUMNS } from './SpeakingCertificationList.columns';

const EMPTY_LIST: SpeakingCertificationListItemResult[] = [];

const INITIAL_TABLE_STATE: TableState<SpeakingCertificationListItemResult, undefined> = {
  pageIndex: 0,
  pageSize: 50,
  sortBy: [],
  filters: undefined,
};

export const SpeakingCertificationList = () => {
  const examinerId = useExaminerId();
  const { permissions } = usePermissions();
  const { tableState, setTableState } = useTableState(INITIAL_TABLE_STATE);

  const canAdd = permissions.includes(Permission.UpdateCertificationHistory);

  const { data, isFetching } = useSpeakingCertificationListQuery({
    examinerId,
    page: tableState.pageIndex + 1,
    count: tableState.pageSize,
  });

  const { data: nextCertDate } = useSpeakingNextCertDateQuery({ examinerId });

  return (
    <SegmentGroup>
      <TitleSegment
        leftSection={
          nextCertDate ? (
            <NextDateLabel
              label="Next Speaking Recertification due date"
              value={formatDate(nextCertDate)}
            />
          ) : (
            <>&nbsp;</>
          )
        }
        rightSection={
          canAdd ? <Button primary as={Link} to="add" icon="plus" content="Add new" /> : undefined
        }
      />
      <SuiTable
        columns={COLUMNS}
        data={data?.results ?? EMPTY_LIST}
        disableFilters
        disableSortBy
        onStateChange={setTableState}
        loading={isFetching}
        state={tableState}
        totalCount={data?.count}
        noResultsMsg="No certifications found"
      />
    </SegmentGroup>
  );
};
